export function heroVideo() {
    const bgv = $('.hero-section-picture video');

    $(window).on("load resize", function () {
        if (bgv.is(':visible')) {
            $('source', bgv).each(
                function() {
                    const el = $(this);
                    if (!el.hasClass('show')) {
                        el.attr('src', el.data('src'));
                        el.addClass('show');
                        bgv[0].load();
                    }
                }
            );
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/hero-video.js